import { render, staticRenderFns } from "./projectfile.vue?vue&type=template&id=308ffdc8&scoped=true&"
import script from "./projectfile.vue?vue&type=script&lang=js&"
export * from "./projectfile.vue?vue&type=script&lang=js&"
import style0 from "./projectfile.vue?vue&type=style&index=0&id=308ffdc8&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308ffdc8",
  null
  
)

export default component.exports